import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import axios from "axios";
import { Base_Uri } from "../Constant/BaseUri";
import { useSelector } from "react-redux";

const AddCashAdjustmentModal = ({ open, onClose, refresh,totalRemaingCashAdjustment }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const userData = useSelector((state) => state.loginReducer.updatedState);
  const [cashInHand,setCashInHand] = useState(0)
  // console.log(totalRemaingCashAdjustment,"totalRemaingCashAdjustment")
  useEffect(()=>{
    console.log(totalRemaingCashAdjustment,"totalRemaingCashAdjustment")
    form.setFieldValue("cash_at_point",Number((totalRemaingCashAdjustment).toFixed()))
  },[totalRemaingCashAdjustment])
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
 let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;


      

      setLoading(true);

      await axios.post(`${Base_Uri}amount/create`, {
        Emplooye_name: userData?.employeeId || "Unknown",
        cash_have: Number(values.cash_have),
        cash_at_point: Number(values.cash_at_point),
        remarks: values.remarks || "",
        status: false, // always pending
      }, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        },);

      message.success("Cash Variance added successfully");

      form.resetFields();
      onClose();
      refresh?.();
    } catch (err) {
      console.log(err);
      message.error("Failed to create adjustment");
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
if (cashInHand) {
     form.setFieldValue("cash_have",Number((cashInHand-totalRemaingCashAdjustment).toFixed()))
}
  },[cashInHand])

  return (
    <Modal
      title="Record Cash Variance"
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={loading}
      okText="Save"
      centered
      className="AddCashAdjustmentModal"
      style={{zIndex:10000000000}}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Cash In hand"
          name="cash_in_hand"
          rules={[{ required: true, message: "Enter Cash In Hand" }]}
        >
          <Input type="number" onChange={((e)=>setCashInHand(e.target.value))} placeholder="Enter Cash In Hand" />
        </Form.Item>
        <Form.Item
          label="Cash Variance"
          name="cash_have"
          rules={[{ required: true, message: "Enter Cash Variance" }]}
        >
          <Input disabled type="number" placeholder="Enter Cash Variance" />
        </Form.Item>

        <Form.Item
          label="Expected Cash "
          name="cash_at_point"
          rules={[{ required: true, message: "Enter Expected Cash " }]}
        >
          <Input disabled type="number" placeholder="Enter Expected Cash " />
        </Form.Item>

        <Form.Item label="Remarks" name="remarks">
          <Input.TextArea rows={3} placeholder="Optional remarks..." />
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default AddCashAdjustmentModal;